<template>
  <a-card>
    <a-field :config="config.depositPercentage" v-model="depositPercentage" />
  </a-card>
</template>

<script>
import config from "../config/clientConfig";

export default {
  data() {
    return {
      config: config,
    };
  },
  computed: {
    depositPercentage: {
      get() {
        const percent = this.get("deposit_percentage");
        return percent ?? 30;
      },
      set(newValue) {
        return this.set("deposit_percentage", newValue);
      },
    },
  },
  methods: {
    get(val) {
      return this.$store.getters["ClientStore/active"][val];
    },
    set(key, val) {
      return this.$store.dispatch("ClientStore/setUpdate", { key, val });
    },
  },
};
</script>
